import { categories } from "@/mocks/naruto";

export default function Footer() {
  return (
    <footer className="w-full bg-background-900 text-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-14">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-1">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-ink-bottle-line text-lg"></i>
              </span>
              <span className="font-display text-xl text-background-50">火影同人本子</span>
            </a>
            <p className="mt-4 text-sm leading-relaxed text-background-100/70">
              一份专注火影同人作品分类与推荐的索引，按CP筛选，让好故事有迹可循。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-100/75">
              {[
                { href: "#categories", label: "CP分类" },
                { href: "#hot", label: "热门推荐" },
                { href: "#guide", label: "阅读指南" },
                { href: "#about", label: "关于我们" },
              ].map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="transition-colors hover:text-primary-300">
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">热门CP</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-100/75">
              {categories.slice(0, 5).map((c) => (
                <li key={c.id}>
                  <a href="#categories" className="transition-colors hover:text-primary-300">
                    {c.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50">联系我们</h4>
            <ul className="mt-4 flex flex-col gap-2.5 text-sm text-background-100/75">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                hello@naruto-doujin.example.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                工作日 10:00 - 18:00
              </li>
              <li>
                <a href="#contact" className="mt-1 inline-block rounded-md bg-primary-500 px-4 py-2 text-sm text-background-50 hover:bg-primary-600">
                  给我们留言
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-background-800 pt-6 text-xs text-background-100/55 sm:flex-row">
          <p>© {new Date().getFullYear()} 火影同人本子 · 本站为同人作品分类与推荐索引</p>
          <p>尊重每一位创作者，请支持正版与原作者</p>
        </div>
      </div>
    </footer>
  );
}